import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import { AppContext } from './../AppContext';
import { useAuth } from '../contexts/AuthContext';
import './NavMenu.css';

export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.loginWithMsal = this.loginWithMsal.bind(this);
        this.logout = this.logout.bind(this);

        this.state = {
            collapsed: true
        };
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    loginWithMsal() {
        if (this.props.handleMsalLogin) {
            this.props.handleMsalLogin();
        }
    }

    logout() {
        this.props.handleLogout();
    }

    render() {
        const currentUser = this.context.currentUser;
        return (
            <header>
                <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" light>
                    <Container>
                        <NavbarBrand tag={Link} to="/">{' '}</NavbarBrand>
                        <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
                        <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
                            <ul className="navbar-nav flex-grow">
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark" to="/materias">Materias</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} className="text-dark" to="/profesores">Profesores</NavLink>
                                </NavItem>
                                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                    <span className="navbar-toggler-icon"></span>
                                </button>
                                {currentUser && currentUser.usuario ?
                                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                        <ul className="navbar-nav ms-auto">
                                            <li className="nav-item">
                                                <a className="nav-link" href="#">Bienvenido(a) : {currentUser.usuario} </a>
                                            </li>
                                            <UncontrolledDropdown nav inNavbar>
                                                <DropdownToggle nav caret>
                                                    Mis opciones
                                                </DropdownToggle>
                                                <DropdownMenu right>

                                                    {currentUser && currentUser.usuario && currentUser.roles
                                                        && currentUser.roles.some(r => r.role == "DOCENTE") &&
                                                        <DropdownItem>
                                                            <NavLink tag={Link} className="dropdown-item text-dark" to="/mis-paralelos">{'Mis paralelos'}</NavLink>
                                                        </DropdownItem>
                                                    }
                                                    {currentUser && currentUser.usuario && currentUser.roles
                                                        && currentUser.roles.some(r => r.role == "DECANO" || r.role == "SUBDECANO") &&
                                                        <>
                                                            <DropdownItem divider />
                                                            <DropdownItem>
                                                                <NavLink tag={Link} className="dropdown-item text-dark" to="/paralelos-unidad">{'Historial de mi unidad'}</NavLink>
                                                            </DropdownItem>
                                                            <DropdownItem>
                                                                <NavLink tag={Link} className="dropdown-item text-dark" to="/programa-evaluacion">{'Evaluación de mi programa'}</NavLink>
                                                            </DropdownItem>
                                                        </>
                                                    }
                                                    {currentUser && currentUser.usuario && currentUser.roles
                                                        && currentUser.roles.some(r => (r.role == "DECANO" && r.scope != "ESPAE") || (r.role == "SUBDECANO" && r.scope != "ESPAE")) &&
                                                        <>
                                                            <DropdownItem>
                                                                <NavLink tag={Link} className="dropdown-item text-dark" to="/unidad-evaluacion">{'Evaluación de mi unidad'}</NavLink>
                                                            </DropdownItem>
                                                        </>
                                                    }
                                                    {currentUser && currentUser.usuario && currentUser.roles
                                                        && currentUser.roles.some(r => (r.role == "DECANO" && r.scope === "DG") || r.role == "COORDINADOR_ADMISIONES" || r.role == "ADMIN") &&
                                                        <>
                                                            <DropdownItem>
                                                            <NavLink tag={Link} className="dropdown-item text-dark" to="/admisiones-evaluacion">{'Evaluación de admisiones'}</NavLink>
                                                            </DropdownItem>
                                                        </>
                                                    }
                                                    {currentUser && currentUser.usuario && currentUser.roles && currentUser.roles.some(r => r.role == "COORDINADOR_CARRERA") &&
                                                        <>
                                                            <DropdownItem>
                                                                <NavLink tag={Link} className="dropdown-item text-dark" to="/carrera-evaluacion">{'Evaluación de mi carrera'}</NavLink>
                                                            </DropdownItem>
                                                        </>
                                                    }
                                                    {currentUser && currentUser.usuario && currentUser.roles
                                                        && currentUser.roles.some(r => ["ADMIN", "COORDINADOR_TECN"].includes(r.role)) &&
                                                        <>
                                                            <DropdownItem>
                                                                <NavLink tag={Link} className="dropdown-item text-dark" to="/reportes-tecnologias">{'Reporte de tutores y servicios'}</NavLink>
                                                            </DropdownItem>
                                                        </>
                                                    }
                                                    {currentUser && currentUser.usuario && currentUser.roles && currentUser.roles.some(r => r.role == "COORDINADOR_PROGRAMA" || r.role == "COORDINADOR_GENERAL") &&
                                                        <>
                                                            <DropdownItem divider />
                                                            <DropdownItem>
                                                                <NavLink tag={Link} className="dropdown-item text-dark" to="/programa-evaluacion">{'Evaluación de mi programa'}</NavLink>
                                                            </DropdownItem>
                                                        </>
                                                    }
                                                    {currentUser && currentUser.usuario && currentUser.roles
                                                        && (currentUser.roles.some(r => r.role == "ADMIN") ||
                                                            currentUser.roles.some(r => ["DECANO", "SUBDECANO", "COORDINADOR_GENERAL", "COORDINADOR_PROGRAMA"].includes(r.role) && r.scope === "ESPAE")) &&
                                                        <>
                                                            <DropdownItem divider />
                                                            <DropdownItem>
                                                                <NavLink tag={Link} className="dropdown-item text-dark" to="/reportes-consolidados">{'Reportes consolidados'}</NavLink>
                                                            </DropdownItem>
                                                        </>
                                                    }
                                                    {currentUser && currentUser.usuario && currentUser.roles
                                                        && currentUser.roles.some(r => r.role == "ADMIN") &&
                                                        <>
                                                            <DropdownItem divider />
                                                            <DropdownItem>
                                                                <NavLink tag={Link} className="dropdown-item text-dark" to="/usuarios">{'Administrar usuarios'}</NavLink>
                                                            </DropdownItem>
                                                            {currentUser && currentUser.usuario && !currentUser.isImpersonated &&
                                                                <DropdownItem>
                                                                    <NavLink tag={Link} className="dropdown-item text-dark" to="/impersonate">{'Ver como'}</NavLink>
                                                                </DropdownItem>
                                                            }
                                                        </>
                                                    }
                                                    <DropdownItem divider />
                                                    <DropdownItem>
                                                        <NavLink tag={Link} className="dropdown-item text-dark" to="#" onClick={this.logout}>{'Cerrar sesión'}</NavLink>
                                                    </DropdownItem>
                                                </DropdownMenu>
                                            </UncontrolledDropdown>
                                        </ul>
                                    </div>
                                    :
                                    <NavItem>
                                        <NavLink tag={Link} className="text-dark" to="#" onClick={this.loginWithMsal}>{'Iniciar sesión'}</NavLink>
                                    </NavItem>
                                }
                            </ul>
                        </Collapse>
                    </Container>
                </Navbar>
            </header>
        );
    }
}
NavMenu.contextType = AppContext;